module.exports = __webpack_public_path__ + "assets/img/01faefb7017dd936ce1a4001ae3ea226.png";